export default __webpack_public_path__ + "locales/es/PeopleTranslations.json?hash=1e269ccd3a93c72e3f525285dca43f2b";